<script>
	import PageBanner from  "$lib/sections/PageBanner.svelte";
	import Features from  "$lib/sections/Features.svelte";

	export let data;

	let lang;
	$: lang = data.lang;

	let area;
	$: area = data.area;

	const col = "contact us";
</script>

<PageBanner {data} {lang} {area} {col} settingId={"PageBanner"} />

<Features {data} {lang} {area} {col} settingId={"Features Contact Us"} />
